const actions = {
  LOAD_RECEPTION: "LOAD_RECEPTION",
  LOAD_RECORDS: "LOAD_RECORDS",
  LOAD_RECORD_DETAIL: "LOAD_RECORD_DETAIL",
  RECORD_IS_LOADING: "RECORD_IS_LOADING",
  CHANGE_DATE: "CHANGE_DATE",
  LOAD_CURRENT_RECORD: "LOAD_CURRENT_RECORD"
};
export default actions;



// WEBPACK FOOTER //
// ./src/redux/constants/portal/records.js